module.exports = __webpack_public_path__ + "static/media/cancel.44ff59ac.svg";